import {RouteConfigBuilder} from "@/calico-vue/service";
/**
 * routes
 */
import Login from "./Login"; //遅延ロードしない

const basePath = "/login";

const Routes = new RouteConfigBuilder(basePath, {
  allowAll: true,
});
export const routes = [Routes.component("", Login)];
